import { useGasv3Listener } from '@atlassian/post-office-context';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useEffect } from 'react';

export const useClickedRovoNudgeDismiss = ({ nudgeId }: { nudgeId: string }): void => {
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const dismissed = useGasv3Listener({
		action: 'dismissed',
		actionSubject: 'rovoButton',
		actionSubjectId: 'aiRovoProactiveNudge',
		attributes: {
			recommendationFeatureId: nudgeId,
			dismissedMethod: 'manual',
		},
	});

	useEffect(() => {
		if (dismissed) {
			void messageInstanceClicked({
				messageEventType: 'clicked',
				clickedElement: {
					clickIdentifier: 'dismiss',
					clickedElement: 'button',
					buttonType: 'primary',
				},
				action: { actionType: 'dismiss' },
				additionalMetadataFromFrontend: {},
			});
		}
	}, [dismissed, messageInstanceClicked]);
};
